import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';

const PRODUCT_TYPE = {
    SILVER_TYPE: 'LARGEAPPLIANCE',
};

export function isSilverProduct(type) {
    return PRODUCT_TYPE.SILVER_TYPE === type;
}

export function isOrderIncludeSilverProduct(orderItems) {
    const silverItem = find(orderItems, (item) => isSilverProduct(item.product.type));
    return !isEmpty(silverItem);
}

export function isOrderIncludeTruckDeliveryItem(orderItems) {
    const truckItem = find(orderItems, (item) => item.product.truckable);
    return !isEmpty(truckItem);
}
